"use client";

import { useCallback } from "react";
import Link from "next/link";

// FIXME... have auth token

interface Props {
    customerId?: string;
    createCustomerAction?: () => Promise<void>;
}

const Customer = ({ customerId, createCustomerAction }: Readonly<Props>) => {
    const action = useCallback(async () => {
        await createCustomerAction?.();
    }, [createCustomerAction]);
    return <form action={action}>
        <h1>Customer</h1>
        <div>
            <button>Create Customer Id</button>
        </div>
        <div>
        {
            customerId && <Link href={`/customer/${customerId}`}>You are customer {customerId}</Link>
        }
        </div>
        </form>;
};

export default Customer;
